import { createFileRoute } from '@tanstack/react-router';
import { HOME_FAQS } from 'features/Landing/content';
import { CtaBand } from 'features/Landing/primitives';
import { ContactPanel } from 'features/Landing/sections/ContactPanel';
import { Faq } from 'features/Landing/sections/Faq';
import { Hero } from 'features/Landing/sections/Hero';
import { Process } from 'features/Landing/sections/Process';
import { ServiceCards } from 'features/Landing/sections/ServiceCards';
import { StatsBand } from 'features/Landing/sections/StatsBand';
import { Testimonials } from 'features/Landing/sections/Testimonials';
import { type FC } from 'react';
import { buildHead, faqJsonLd } from 'seo/head';

const HomePage: FC = () => (
  <>
    <Hero />
    <ServiceCards />
    <StatsBand />
    <Process />
    <Testimonials />
    <Faq faqs={HOME_FAQS} />
    <ContactPanel />
    <CtaBand />
  </>
);

export const Route = createFileRoute('/_landing/')({
  head: () =>
    buildHead({
      title: 'Concrete Foundations Hamilton & Waikato | Dreams Built',
      description:
        'Dreams Built pours residential foundations, concrete driveways and patios across Hamilton and the Waikato, for group builders and homeowners. 600+ floors since 2015. Free fixed quotes.',
      path: '/',
      jsonLd: [faqJsonLd([...HOME_FAQS])]
    }),
  component: HomePage
});
